export default "__VITE_ASSET__AhSlFXnq__"